import { StyleSheet } from "react-native";
import { fonts } from "../../../styles/theme";


const IraAccountStyle = StyleSheet.create({
  container: {
      flex: 1,
      backgroundColor:"#FFFFFF",
      
  },
  header: {
      backgroundColor: '#fff',
      paddingVertical: 20,
  },
  headerText: {
    fontSize: 22,
    fontWeight: '600',
    paddingLeft: 10,
    fontFamily: fonts.regular,
    marginLeft:7
},
  content: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: 20,
      marginTop:15
      
  },
  iconContainer: {
      backgroundColor: '#fff', 
      padding: 50, 
      borderRadius: 19,
      shadowColor: "gray",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 10,
      alignItems: 'center', 
      width:410,
  },
  image: {
      width: 150,
      height: 150,
      tintColor: '#3629B7',
  },
  textContainer: {
      marginTop: 20, 
      backgroundColor: '#fff',
      padding: 20, 
      borderRadius: 19,
      shadowColor: "gray",
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowOpacity: 0.2,
      shadowRadius: 8,
      elevation: 10,
      alignItems: 'center', 
      width: 410,
      fontWeight:"bold",
      fontSize:100
  },
  text: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#666',
      textAlign: 'center', 
      fontFamily: fonts.regular,
  },
});
export default IraAccountStyle;